import React, { lazy, Suspense } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../webpack/chunkRetry';
const LoadableTools = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "devtools" */ '@hookform/devtools').then((module)=>({
                default: module.DevTool
            }))));
const HookFormDevtools = (props)=>{
    const isMounted = useIsMounted();
    const enabled = useFlag('hookform_devtools');
    if (!isMounted || !enabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "HookFormDevtools"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(LoadableTools, props)));
};
HookFormDevtools.displayName = 'HookFormDevtools';
export default HookFormDevtools;
